// Official HAROON TRADING logo (derived transparent crops of the supplied PNG). Swap files in /public/media/brand.
const BRAND = "/media/brand";

export const Logo = ({ tone = "light", layout = "lockup", className = "" }) => {
  if (layout === "full") {
    return (
      <img
        src={`${BRAND}/logo-full-${tone}.png`}
        alt="HAROON TRADING — Used Cars • Export • Trust"
        width={955}
        height={712}
        className={className}
        data-testid="logo-full"
      />
    );
  }
  return (
    <span className={`flex items-center gap-2.5 sm:gap-3 ${className}`} data-testid="logo-lockup">
      <img src={`${BRAND}/emblem.png`} alt="" width={462} height={539} className="h-[42px] w-auto sm:h-12" />
      <img
        src={`${BRAND}/wordmark-${tone}.png`}
        alt="HAROON TRADING"
        width={951}
        height={122}
        className="h-[21px] w-auto sm:h-[26px]"
      />
    </span>
  );
};
